import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  TextField,
  DialogContent,
  Typography,
} from '@mui/material';
import HTTP from '../../services/http';
import therapyList from './therapies';

type MinifakerModule = typeof import('minifaker');

const saveInLocalStore = (key: any, value: any) => {
  const current_value = JSON.parse(
    localStorage.getItem('arbor_shortcuts_create_patient_config') || '{}',
  );
  const new_value = JSON.stringify({ ...current_value, [key]: value });
  localStorage.setItem('arbor_shortcuts_create_patient_config', new_value);
};
function sendMessage(msg: string) {
  console.log(msg);
}
const randomNumberOfLengthX = (x: number) => {
  const base = 10 ** (x - 1);
  return Math.floor(base + Math.random() * (9 * base));
};

const currentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = `${now.getMonth() + 1}`.padStart(2, '0');
  const day = `${now.getDate()}`.padStart(2, '0');
  const hours = `${now.getHours()}`.padStart(2, '0');
  const minutes = `${now.getMinutes()}`.padStart(2, '0');
  const seconds = `${now.getSeconds()}`.padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

// Create an AR
async function createAR(therapies: any[], clinic: any, patient_id: any) {
  sendMessage('Creating AR Task');
  const now = new Date();
  const rawFUD = new Date(now.setDate(now.getDate() + 14));
  const arFUD = `${rawFUD.getFullYear()}-${rawFUD.getMonth() + 1}-${rawFUD.getDate()}`;
  const rawScheduleDate = new Date(new Date().setDate(new Date().getDate() + 3));
  const arScheduleDate = `${rawScheduleDate.getFullYear()}-${
    rawScheduleDate.getMonth() + 1
  }-${rawScheduleDate.getDate()}`;
  const therapiesForAR = therapies.map(therapy => ({
    ndc: therapy.ndc,
    gpi: therapy.gpi,
  }));
  const arBody = {
    communication_type_id: 4,
    followup_dt: arFUD,
    managing_clinic_id: clinic.id,
    note: 'Added using Arbor Shortcuts',
    patient_id: patient_id,
    reason_id: 7,
    scheduled_date: arScheduleDate,
    service_group_id: clinic.service_group_id,
    therapies: therapiesForAR,
  };
  console.log('ar: ', arBody);
  const newAResponse = await HTTP.post('/tasks/ar', arBody);
  const newAR = newAResponse.data.added_task[0];
  console.log('newAR: ', newAR);
  return newAR;
}

function pickTherapies(x: number, type: 'specialty') {
  console.log('running pickTherapies');
  const options = therapyList[type].slice();
  const picked = [];
  for (let i = 0; i < x; i += 1) {
    console.log('i: ', i);
    const r1 = Math.floor(Math.random() * options.length);
    const pickedTherapy = options[r1];
    const r2 = Math.floor(Math.random() * pickedTherapy.icds.length);
    const pickedICD = pickedTherapy.icds[r2];
    const compositeTherapy = {
      name: pickedTherapy.name,
      ndc: pickedTherapy.ndc,
      gpi: pickedTherapy.gpi,
      icd: pickedICD,
    };
    picked.push(compositeTherapy);
    options.splice(r1, 1);
  }

  return picked;
}
// Add therapies
async function createTherapies(
  therapies: any[],
  new_patient_id: number,
  clinic: any,
  emrToUse: any,
  ar: any,
) {
  const url_segments = window.location.href.split('/');
  const customer_id = url_segments.reduce((accumulator: any, seg, index) => {
    accumulator = seg === 'customers' ? url_segments[index + 1] : accumulator;
    return accumulator;
  }, null);
  const ndc1_override = undefined; // await ls.getItem("ndc1");
  const icd1_override = undefined; // await ls.getItem("icd1");
  const ndc2_override = undefined; // await ls.getItem("ndc2");
  const icd2_override = undefined; // await ls.getItem("icd2");
  const therapiesToValidate = therapies;
  const pharmaciesResponse = await HTTP.get(`/customers/${customer_id}/pharmacies`);
  const pharaciesList = pharmaciesResponse.data.dispensingPharmacies;
  const pharmacy = pharaciesList[Math.floor(Math.random() * pharaciesList.length)];
  console.log('pharmacy: ', pharmacy);
  const ndc_overrides = [ndc1_override, ndc2_override];
  const idc_overrides = [icd1_override, icd2_override];

  const pbm_insurance = {
    patient_id: new_patient_id,
    insurance_type_id: 1,
    pbm_name: 'Arbor Shortcuts',
    pbm_phone_number: null,
    pbm_patient_id: `${randomNumberOfLengthX(7)}`,
    pbm_bin_number: `${randomNumberOfLengthX(6)}`,
    pbm_relation_code: '1',
    pbm_rx_group_number: `AS-${randomNumberOfLengthX(5)}`,
    pbm_processor_control_number: `${randomNumberOfLengthX(6)}`,
    start_date: null,
    end_date: null,
    is_verified: 1,
    verified_dt: currentDateTime(),
    verified_by: null,
    lis_effective_date: null,
    lis_effective_date_mbi: null,
    lis_termination_date: null,
    lis_date_of_service: null,
    lis_next_medicare_part_d_termination: null,
    lis_next_medicare_part_d_effective_start: null,
  };
  console.log('pbm_object: ', pbm_insurance);
  const pbmResponse = await HTTP.get(`patients/${new_patient_id}/pbm-insurances`);
  const insurance_output = pbmResponse.data;
  console.log('insurance_output: ', insurance_output);

  console.log('therapiesToValidate: ', JSON.stringify(therapiesToValidate));
  for (let i = 0; i < therapiesToValidate.length; i += 1) {
    sendMessage(`Creating Therapy ${i + 1}`);
    const ndc_override = ndc_overrides[i];
    const icd_override = idc_overrides[i];
    const entry = therapiesToValidate[i];
    const referral_date_raw = new Date();
    const referral_date = `${referral_date_raw.getFullYear()}-${
      referral_date_raw.getMonth() + 1
    }-${referral_date_raw.getDate()} 04:00:00`;
    const nbd_raw = new Date(new Date().setDate(new Date().getDate() + 7));
    const nbd = `${nbd_raw.getFullYear()}-${nbd_raw.getMonth() + 1}-${nbd_raw.getDate()}`;
    const therapy = {
      patient_id: new_patient_id,
      ndc: ndc_override || entry.ndc,
      lead_source_id: '2',
      rx_type_id: '2',
      referring_clinic_npi: clinic.npi,
      referring_clinic_name: clinic.name,
      referring_clinic_internal_id: clinic.id,
      managing_clinic_id: clinic.id,
      managing_clinic_name: clinic.name,
      dispensing_status_id: 2,
      enrollment_status_id: 12001,
      administration_status_id: 1001,
      referral_dt: referral_date,
      needsby_date: nbd,
      days_supply: '30',
      is_needsby_per_protocol: null,
      service_group_id: clinic.service_group_id,
      diagnosis_code: icd_override || therapies[i].icd,
      prescribing_physician_npi: '1932720588',
      prescribing_physician_name: 'MAKINDE, JACQUELINE',
      is_specialty: true,
      dispensing_pharmacy_npi: pharmacy.npi,
      dispensing_pharmacy_name: pharmacy.name,
      transfer_pharmacy_npi: null,
      transfer_pharmacy_name: null,
      therapy_duration: 0,
      active: 1,
      source_id: emrToUse.id,
      category_code: 'outpatient',
      dosis_regimen: 'per label',
      as_needed: false,
      medication_id: null,
      dispensing_pharmacy_doing_business_as: '',
      transfer_pharmacy_doing_business_as: null,
      clinical_support_status_id: 4,
      clinical_support_status_reason: null,
    };
    const therapy_response = await HTTP.post(`patients/${new_patient_id}/therapies`, therapy);
    const newTherapy_response = therapy_response.data;
    console.log('ndc_override: ', ndc_override);
    console.log('adding: ', ndc_override ? `override ${i}` : entry.name);
    console.log('newTherapy_response: ', newTherapy_response);
    const newTherapy = newTherapy_response.therapy;
    const linkBody = {
      ndc: ndc_override || entry.ndc,
      therapy_id: newTherapy.id,
    };
    const linkResponse = await HTTP.patch(`tasks/so/${ar.id}/links/therapies`, linkBody);
    const linkResponseJson = linkResponse.data;
    console.log('linkResponseJson: ', linkResponseJson);
  }
}

let faker: MinifakerModule;

function createDOB() {
  const minAge = 1;
  const maxAge = 100;
  const oldest = new Date();
  oldest.setFullYear(oldest.getFullYear() - maxAge);

  const youngest = new Date();
  youngest.setFullYear(youngest.getFullYear() - minAge);

  const ts = faker.number({
    min: oldest.getTime(),
    max: youngest.getTime(),
  });

  const dob = new Date(ts);

  const yyyy = dob.getFullYear();
  const mm = String(dob.getMonth() + 1).padStart(2, '0');
  const dd = String(dob.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

async function createPatient(details: any) {
  const fn_override = details.first_name;
  const ln_override = details.last_name;
  const phone_override_raw = details.phone;
  console.log('por: ', phone_override_raw);
  const phone_override_parts = phone_override_raw?.split('-');
  console.log('phone_override_parts: ', phone_override_parts);
  const phone_override = phone_override_parts
    ? `(${phone_override_parts[0]}) ${phone_override_parts[1]}-${phone_override_parts[2]}`
    : null;
  console.log('phone_override: ', phone_override);
  const dob_override = details.dob;
  // get EMR data
  const emrsRequest = await HTTP.get('/customers/me/emrs');
  console.log('emrsRequest: ', emrsRequest);
  const emrs = emrsRequest?.data?.emrs;
  const emrToUse = emrs[Math.floor(Math.random() * emrs.length)];
  console.log('emrs: ', emrs);
  console.log('emrToUse: ', emrToUse);

  // // get clinic data
  const clinicsRequest = await HTTP.get('/lookup/customer-clinics');
  const validClinics = clinicsRequest?.data?.clinics.filter(
    (clinic: any) => clinic.active && clinic.service_group_id,
  );
  const clinicsPick = Math.floor(Math.random() * validClinics?.length);
  const clinic = validClinics[clinicsPick];
  console.log('clinic: ', clinic);

  // // create new patient

  const randomBit = Math.random() < 0.5 ? 0 : 1;
  const gender = randomBit ? 'male' : 'female';

  const first_name = fn_override || faker.firstName({ gender });
  const last_name = ln_override || faker.lastName();
  const bday_full = createDOB();
  const address = faker.streetAddress();
  console.log('first_name: ', first_name);
  console.log('last_name: ', last_name);
  console.log('dob: ', bday_full);
  console.log('address: ', address);
  const number = faker.number({ min: 10, max: 1000 });
  const street = faker.streetName();
  const city = faker.cityName();
  const configValues = JSON.parse(
    localStorage.getItem('arbor_shortcuts_create_patient_config') || '{}',
  );
  const state = configValues.state || 'GA';
  const zip = faker.zipCode();
  const fullAddress = JSON.stringify([
    {
      use: 'Home',
      line1: `${number} ${street}`,
      city: city,
      state: state,
      zip,
      key: 1,
      rank: 1,
    },
  ]);
  console.log('fullAddress: ', fullAddress);
  const areaCode = '404';
  const phoneNumber = `(${areaCode}) 555-1393`;
  const phoneValue = JSON.stringify([
    {
      use: 'Mobile',
      value: phoneNumber,
      key: 1,
      sms: 'Opt in',
      period: '08:00-20:00',
    },
  ]);
  const patient = {
    addresses: fullAddress,
    dob: bday_full,
    email_options: null,
    emails: null,
    first_name: first_name,
    gender: gender,
    is_declined_to_provide_addresses: 0,
    is_declined_to_provide_phones: 0,
    languages: null,
    last_name: last_name,
    phones: phoneValue,
    source_id: emrToUse.id,
    source_patient_id: `AS-${Math.random().toString(36).slice(2)}`,
  };
  console.log('patient: ', patient);

  const new_patient = await HTTP.post('/patients', patient);

  return { clinic, emrToUse, new_patient_id: new_patient.data.added_patient.id };
}
const CreatePatient: React.FC<any> = props => {
  const { close } = props;
  const [minifaker, setMinifaker] = useState<MinifakerModule | null>(null);
  const [render, forceRender] = useState(1);
  const [statusMessage, setStatusMessage] = useState('');
  const [disableCreate, setDisableCreate] = useState(false);
  const configValues = JSON.parse(
    localStorage.getItem('arbor_shortcuts_create_patient_config') || '{}',
  );
  const [therapy1, setTherapy1] = useState(configValues.therapy1);
  const [therapy1Invalid, setTherapy1Invalid] = useState(!therapy1);
  console.log('rendering CreatePatient');
  console.log('configValues: ', configValues);
  const create_new_patient = async (open: boolean) => {
    setDisableCreate(true);
    setStatusMessage('Creating new patient');
    const { clinic, emrToUse, new_patient_id } = await createPatient(configValues);
    const therapies = pickTherapies(3, 'specialty');
    setStatusMessage('Creating AR Task');
    const ar = await createAR(therapies, clinic, new_patient_id);
    setStatusMessage('Creating Therapies');
    const new_therapies = await createTherapies(therapies, new_patient_id, clinic, emrToUse, ar);
    const current_url_parts = window.location.href.split('/patients/');
    const patient_parts = current_url_parts[1].split('/');
    patient_parts[0] = `${new_patient_id}`;
    const new_patient_url = `${current_url_parts[0]}/patients/${patient_parts.join('/')}`;
    console.log('new_patient_url: ', new_patient_url);
    setStatusMessage('Done');
    setDisableCreate(false);
    if (open) {
      window.location.href = new_patient_url;
    }
  };
  useEffect(() => {
    (async () => {
      const module = await import('minifaker');
      await import('minifaker/locales/en');
      setMinifaker(module);
      faker = module;
    })();
  }, []);
  const therapyOptions: string[] = ['A', 'B', 'C'];
  console.log('name: ', minifaker?.name());
  const text_inputs = [
    { key: 'first_name', label: 'First name' },
    { key: 'last_name', label: 'Last name' },
    { key: 'phone_number', label: 'Phone number' },
    { key: 'dob', label: 'Date of Birth' },
    { key: 'state', label: 'State' },
  ];

  const saveChanges = (key: string, value: string) => {
    console.log('saveChanges.key: ', key);
    console.log('saveChanges.value: ', value);
    saveInLocalStore(key, value);
    forceRender(render + 1);
  };
  return (
    <Dialog open PaperProps={{ sx: { width: '80vw', height: '80vh', maxWidth: 'none' } }}>
      <DialogTitle>Create a new Patient (Preview)</DialogTitle>
      <div className="contextmenu">
        <DialogContent>
          <div style={{ width: '25%' }}>
            {text_inputs.map(input => {
              return (
                <TextField
                  key={input.key}
                  sx={{ padding: '10px', boxSizing: 'border-box' }}
                  fullWidth
                  label={input.label}
                  value={configValues[input.key]}
                  autoFocus
                  onChange={e => saveChanges(input.key, e.target.value)}
                />
              );
            })}
          </div>
        </DialogContent>
        Status Message
        <Typography>{statusMessage}</Typography>
      </div>
      <DialogActions>
        <Button onClick={close}>Close</Button>
        <Button
          disabled={disableCreate}
          onClick={() => {
            create_new_patient(true);
          }}
        >
          Create and open new patient
        </Button>
        <Button
          disabled={disableCreate}
          onClick={() => {
            create_new_patient(false);
          }}
        >
          Create Patient
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreatePatient;
